import * as AC from '../actions/actionTypes';
import {updateObject} from '../utils/utilities';

const intitialState = {
  entrances: [],
  buildingEntrances: [],
  entrancesPage: 1,
  entrancesTotalPages: 1,
  buildingEntrancesPage: 1,
  buildingEntrancesTotalPages: 1,
  entranceById: null,
  entrancesLoading: false,
  entrancesError: '',
};

const entrancesReducer = (state = intitialState, action) => {
  switch (action.type) {
    case AC.GET_ENTRANCES_REQUEST:
    case AC.GET_BUILDING_ENTRANCES_REQUEST:
    case AC.GET_ENTRANCE_DETAILS_REQUEST:
    case AC.ADD_ENTRANCE_REQUEST:
    case AC.EDIT_ENTRANCE_REQUEST:
    case AC.DELETE_ENTRANCE_REQUEST:
      return updateObject(state, {entrancesLoading: true, entrancesError: ''});
    case AC.GET_ENTRANCES_SUCCEED:
      return updateObject(state, {
        entrances: action.payload,
        entrancesPage: action.page,
        entrancesTotalPages: action.totalPages,
        entrancesLoading: false,
      });
    case AC.GET_BUILDING_ENTRANCES_SUCCEED:
      return updateObject(state, {
        buildingEntrances: action.payload,
        buildingEntrancesPage: action.page,
        buildingEntrancesTotalPages: action.totalPages,
        entrancesLoading: false,
      });
    case AC.GET_ENTRANCE_DETAILS_SUCCEED:
      return updateObject(state, {
        entranceById: action.payload,
        entrancesLoading: false,
      });
    case AC.GET_ENTRANCES_FAILED:
    case AC.GET_BUILDING_ENTRANCES_FAILED:
    case AC.GET_ENTRANCE_DETAILS_FAILED:
    case AC.ADD_ENTRANCE_FAILED:
    case AC.EDIT_ENTRANCE_FAILED:
    case AC.DELETE_ENTRANCE_FAILED:
      return updateObject(state, {
        entrancesError: action.payload,
        entrancesLoading: false,
      });
    default:
      return state;
  }
};

export default entrancesReducer;
